import { render, staticRenderFns } from "./MutiCard.vue?vue&type=template&id=788c1b45&scoped=true&"
import script from "./MutiCard.vue?vue&type=script&lang=js&"
export * from "./MutiCard.vue?vue&type=script&lang=js&"
import style0 from "./MutiCard.vue?vue&type=style&index=0&id=788c1b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c1b45",
  null
  
)

export default component.exports